// import { useSelector } from "react-redux";

// export function usePermissions() {
//   const privileges = useSelector(
//     (state) => state?.privilegesReducer?.rbacPrivileges,
//   );
//   function hasPermission(permission, eitherOr) {
//     if (eitherOr === "eitherOr") {
//       return permission.some((p) => privileges.includes(p));
//     }
//     return permission.every((p) => privileges.includes(p));
//   }

//   return { hasPermission, privileges };
// }


import { useSelector } from "react-redux";

export function usePermissions() {
  const rbacPrivileges = useSelector(
    (state) => state?.privilegesReducer?.rbacPrivileges,
  );

  const apiPrivileges = useSelector(
    (state) => state?.authReducer?.userData?.product_Privileges,
  );

  const privileges =
    Array.isArray(rbacPrivileges) && rbacPrivileges.length > 0
      ? rbacPrivileges
      : typeof apiPrivileges === "string"
        ? apiPrivileges
            .split(",")
            .map((privilege) => privilege.trim())
            .filter(Boolean)
        : Array.isArray(apiPrivileges)
          ? apiPrivileges
          : [];

  const hasPermission = (permission, eitherOr) => {
    if (!permission) {
      return false;
    }

    const requiredPrivileges = Array.isArray(permission)
      ? permission
      : [permission];

    if (eitherOr === "eitherOr") {
      return requiredPrivileges.some((privilege) =>
        privileges.includes(privilege),
      );
    }

    return requiredPrivileges.every((privilege) =>
      privileges.includes(privilege),
    );
  };

  return {
    hasPermission,
    privileges,
  };
}